import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';

import { PORTFOLIO_DETAIL_CUSTOMER_LIST_HEADER } from '@constants/tableheader';

/** 포트폴리오 상세 > 주요거래처 > 매출/매입 스켈레톤 */
const IncomeAndSalesSkeleton = () => {
  const tableData = useMemo(
    () =>
      Array.from({ length: 10 }).map((_: any, i: number) => ({
        id: i,
        type: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        rate: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        amount: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      })),
    []
  );

  return (
    <>
      <div css={titleStyle}>
        <Skeleton variant="text" width={180} />
      </div>
      <div css={reference}>
        <Skeleton variant="text" width={120} />
      </div>
      <Table header={PORTFOLIO_DETAIL_CUSTOMER_LIST_HEADER} data={tableData} />

      <div css={[titleStyle, { marginTop: '80px' }]}>
        <Skeleton variant="text" width={180} />
      </div>
      <div css={reference}>
        <Skeleton variant="text" width={120} />
      </div>
      <Table header={PORTFOLIO_DETAIL_CUSTOMER_LIST_HEADER} data={tableData} />
    </>
  );
};

export default IncomeAndSalesSkeleton;

const reference = css`
  display: flex;
  font-size: 12px;
  justify-content: flex-end;
  margin-bottom: 5px;
`;

const items = css`
  display: flex;
  justify-content: center;
`;
